import { render, staticRenderFns } from "./PlantCard.vue?vue&type=template&id=4e596b54&scoped=true"
import script from "./PlantCard.vue?vue&type=script&lang=js"
export * from "./PlantCard.vue?vue&type=script&lang=js"
import style0 from "./PlantCard.vue?vue&type=style&index=0&id=4e596b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e596b54",
  null
  
)

export default component.exports